const baseUrl = 'https://api.unsplash.com';
const featuredCollections =[
    'Technology',
    'Animals',
    'Wallpapers',
    'Patterns',
    'Whatsapp',
    'Love',
    'Flowers',
    'Roses',
    'Spring',
    'Alexandria',
    'Cars',
    'Winter',
    'Fish',
    'Letters',
    'Session',
    'Rain',
    'Children',
    'Wedding',
    'Search',
    'Google',
    'Youtube',
    'Pintrest',
    'Nature', 
    'Learn',
    'Code',
    'Garden',
    'People',
    'Languages',
    'Desktops',
    'Mobile',
    'Screen',
    'Device'
]
export  {
    baseUrl,
    featuredCollections
}